import { dayjs, Dayjs } from "../../../lib";
import { debounce } from "../../../utils";

export const buildGraphicEvents = (
  handleZoom: (isZoomActive: boolean, start?: Dayjs, end?: Dayjs) => void,
) => ({
  brush: debounce((event?: { command: string }) => {
    if (event?.command === 'clear') {
      handleZoom(false);
    }
  }, 1000),
  brushEnd: (event: { areas: { coordRange: number[] }[] }) => {
    const [zoomStartDate, zoomEndDate] = event.areas?.[0]?.coordRange || [];

    handleZoom?.(true, dayjs(zoomStartDate), dayjs(zoomEndDate));
  },
});
